import { render, staticRenderFns } from "./selaDressReservStats.vue?vue&type=template&id=ee8b1d18&scoped=true"
import script from "./selaDressReservStats.vue?vue&type=script&lang=js"
export * from "./selaDressReservStats.vue?vue&type=script&lang=js"
import style0 from "./selaDressReservStats.vue?vue&type=style&index=0&id=ee8b1d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8b1d18",
  null
  
)

export default component.exports